import { render, staticRenderFns } from "./RegisterModel.vue?vue&type=template&id=6dce1cdc"
import script from "./RegisterModel.vue?vue&type=script&lang=js"
export * from "./RegisterModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports